import React from 'react';
import PropTypes from 'prop-types';

function Bold({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M8 6H13.3333C14.0406 6 14.7189 6.31607 15.219 6.87868C15.719 7.44129 16 8.20435 16 9C16 9.79565 15.719 10.5587 15.219 11.1213C14.7189 11.6839 14.0406 12 13.3333 12H8V6Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12H14.2308C14.9652 12 15.6696 12.3161 16.1889 12.8787C16.7082 13.4413 17 14.2044 17 15C17 15.7956 16.7082 16.5587 16.1889 17.1213C15.6696 17.6839 14.9652 18 14.2308 18H8V12Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Bold.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Bold;
